import {
    ChartBarIcon,
    ClipboardDocumentListIcon,
    AdjustmentsHorizontalIcon,
    ListBulletIcon
} from '@heroicons/react/24/outline';

import {
    ROLE_ADMIN,
    ROLE_COLLABORATOR_ADMIN,
    ROLE_COLLABORATOR_EDITOR,
    ROLE_COLLABORATOR_VIEWER,
    ROLE_EVALUATION_ADMIN,
} from '@/contexts/AuthContext';
import type { NavigationItem } from '@/contexts/ModuleNavigationContext';

const peopleRoles = [
    ROLE_ADMIN,
    ROLE_COLLABORATOR_ADMIN,
    ROLE_COLLABORATOR_VIEWER,
    ROLE_COLLABORATOR_EDITOR,
];

const evaluationRoles = [
    ROLE_ADMIN,
    ROLE_EVALUATION_ADMIN,
];

export const peopleNavigationItems: NavigationItem[] = [
    {
        name: 'Dashboard',
        href: '/people',
        icon: ChartBarIcon,
        exact: true,
        requiredRoles: [...peopleRoles, ROLE_EVALUATION_ADMIN],
    },
    {
        name: 'Avaliações',
        href: '/people/evaluations',
        icon: ClipboardDocumentListIcon,
        exact: true,
        requiredRoles: evaluationRoles,
    },
    {
        name: 'Questionários',
        href: '/people/evaluations/questionnaires',
        icon: ListBulletIcon,
        requiredRoles: evaluationRoles,
    },
    {
        name: 'Escalas',
        href: '/people/evaluations/scales',
        icon: AdjustmentsHorizontalIcon,
        requiredRoles: evaluationRoles,
    },
];
